import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {UseLoader} from "../../../hooks/useLoader";
import {confirmDialog} from "primereact/confirmdialog";

import {editarCompensacion} from "../../../api/compensacion.service";
import {Toast} from "primereact/toast";
import {Dialog} from "primereact/dialog";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {error} from "../../../shared/utils/utils";

export const ModalEditarCompensacion = ({show, hide, fields}) => {
    const [handleLoad] = UseLoader();
    const toast = useRef(null);
    const initParams = {
        cuentacompensa_id: '',
        descripcion: "",
        descA: "",
        porcentaje: "",
        orden: "",
        estado: "",
        tipo_cuenta: "",
        base_denomidor: "",
        cuenta_pasivo: "",
        cuenta_gasto: "",
    };

    const [field, setField] = useState(initParams);

    useEffect(() => {
        setField({
            cuentacompensa_id: fields.cuentacompensa_id,
            descripcion: fields.descripcion,
            descA: fields.descrip_abrev,
            porcentaje: fields.porcentaje,
            orden: fields.orden,
            estado: fields.estado,
            tipo_cuenta: fields.tipo_cuenta_id,
            base_denomidor: fields.base_denominador_id,
            cuenta_gasto: fields.cuenta_gasto,
            cuenta_pasivo: fields.cuenta_pasivo,
        })

        return () => {
            setField(initParams)
        };
    }, [fields]);


    const onSubmit = async (e) => {
        try {
            e.preventDefault();
            if (field.cuentacompensa_id === ''
                || field.descripcion === ''
                || field.descA === ''
                || field.porcentaje === ''
                || field.orden === ''
                || field.estado === ''
                || field.tipo_cuenta === ''
                || field.base_denomidor === ''
                || field.cuenta_gasto === ''
                || field.cuenta_pasivo === ''
            ) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Validar campos",
                    life: 3000
                });
                return;
            }

            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () =>  {
                    handleLoad(true)
                    const response = await editarCompensacion(field);
                    const data = await response.data;
                    handleLoad(false)
                    if (data.estado !== 200) {
                        toast.current?.show({severity: 'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                    hide()

                }
            });

        } catch (e) {
            handleLoad(false)
            console.log(e)
        }

    }
    return (
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Editar Compensacion" visible={show} style={{width: '90vw'}}
                    onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={onSubmit} autoComplete="false">
                            <h6 className="title-modal">
                                Información compensación
                            </h6>
                            <div className="row">
                                <ContainerGroupForm width="lg:w-6/12">
                                    <label
                                        className="label-form"
                                        htmlFor="descr"
                                    >
                                        Descripcion *
                                    </label>
                                    <textarea
                                        name="desc"
                                        className="form-input-small"
                                        value={field.descripcion}
                                        onChange={(e) => setField({...field, descripcion: e.target.value})}
                                        id="desc" rows="1">
                                </textarea>
                                    {error(field.descripcion, 'required')}
                                    {error(field.descripcion, 'maxLength', 100)}

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-6/12">
                                    <label
                                        className="label-form"
                                        htmlFor="descA"
                                    >
                                        Descripcion abrev *
                                    </label>
                                    <input
                                        id="descA"
                                        type="text"
                                        className="form-input-small"
                                        value={field.descA}
                                        onChange={(e) => setField({...field, descA: e.target.value})}
                                    />
                                    {error(field.descA, 'required')}
                                    {error(field.descA, 'maxLength', 40)}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="orden"
                                    >
                                        Orden *
                                    </label>
                                    <input
                                        id="orden"
                                        type="number"
                                        className="form-input-small"
                                        value={field.orden}
                                        onChange={(e) => setField({...field, orden: e.target.value})}
                                    />
                                    {error(field.orden, 'required')}
                                    {error(field.orden, 'maxLength', 6)}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="tipocuen"
                                    >
                                        Tipo cuenta *
                                    </label>
                                    <select
                                        className="form-input-small"
                                        value={field.tipo_cuenta}
                                        onChange={(e) => setField({...field, tipo_cuenta: e.target.value})}
                                        id="tipocuen">
                                        <option value="">seleccione</option>
                                        <option value="P">Prestacional</option>
                                        <option value="C">Compensación</option>
                                    </select>
                                    {error(field.tipo_cuenta, 'required')}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="porcentaje"
                                    >
                                        Porcentaje *
                                    </label>
                                    <input
                                        value={field.porcentaje}
                                        onChange={(e) => setField({...field, porcentaje: e.target.value})}
                                        id="porcentaje"
                                        type="number"
                                        className="form-input-small"
                                    />
                                    {error(field.porcentaje, 'required')}
                                    {error(field.porcentaje, 'maxLength', 11)}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="base_denomidor"
                                    >
                                        Base denominador *
                                    </label>
                                    <select
                                        value={field.base_denomidor}
                                        onChange={(e) => setField({...field, base_denomidor: e.target.value})}
                                        className="form-input-small"
                                        id="base_denomidor">
                                        <option value="">seleccione</option>
                                        <option value="P">Prestacional</option>
                                        <option value="C">Compensación</option>
                                    </select>
                                    {error(field.base_denomidor, 'required')}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="cuenta_pasivo"
                                    >
                                        Cuenta pasivo *
                                    </label>
                                    <input
                                        type="number"
                                        value={field.cuenta_pasivo}
                                        onChange={(e) => setField({...field, cuenta_pasivo: e.target.value})}
                                        id="cuenta_pasivo"
                                        className="form-input-small"
                                    />
                                    {error(field.cuenta_pasivo, 'required')}
                                    {error(field.cuenta_pasivo, 'maxLength', 20)}
                                </ContainerGroupForm>


                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="cuenta_gasto"
                                    >
                                        Cuenta gasto *
                                    </label>
                                    <input
                                        type="number"
                                        value={field.cuenta_gasto}
                                        onChange={(e) => setField({...field, cuenta_gasto: e.target.value})}
                                        id="cuenta_gasto"
                                        className="form-input-small"
                                    />
                                    {error(field.cuenta_pasivo, 'required')}
                                    {error(field.cuenta_pasivo, 'maxLength', 20)}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="estado"
                                    >
                                        Estado
                                    </label>
                                    <select
                                        value={field.estado}
                                        onChange={(e) => setField({...field, estado: e.target.value})}
                                        className="form-input-small"
                                        id="estado">
                                        <option value="">seleccione</option>
                                        <option value="A">Activo</option>
                                        <option value="I">Inactivo</option>
                                    </select>
                                    {error(field.estado, 'required')}
                                </ContainerGroupForm>
                            </div>

                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Guardar
                                    </button>

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>

                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>
            </Dialog>

        </>
    );
};

ModalEditarCompensacion.propTypes = {
    show: PropTypes.bool,
    hide: PropTypes.func,
    fields: PropTypes.object
};

ModalEditarCompensacion.defaultProps = {
    show: false,
};


